"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var Below = function Below(_ref) {
  var noErrorsOrHelper = _ref.noErrorsOrHelper,
    error = _ref.error,
    errorText = _ref.errorText,
    description = _ref.description;
  if (!noErrorsOrHelper && error) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "OTPInput__description OTPInput__description--error",
      "aria-live": "assertive",
      children: errorText
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: "OTPInput__description",
    "aria-live": "assertive",
    children: description
  });
};
var _default = Below;
exports["default"] = _default;